import { useCallback, useEffect, useState } from 'react';
import { CanvasMountRef } from './PreviewDisplay';
import { FULLSCREEN_CHANGE_EVENTS, isElementFullscreen, isFullscreenSupported, toggleElementFullscreen } from '../../../../utilities/fullscreenUtilities';

// Shared by the toolbar button and the Features panel switch so both follow the same preview
// fullscreen state.
const useFullscreenPreview = () => {
    const [isFullscreen, setIsFullscreen] = useState(() => isElementFullscreen(CanvasMountRef.current));

    // The browser can leave fullscreen on its own (Esc, a system gesture), so the state follows the
    // browser rather than the last click.
    useEffect(() => {
        const syncWithBrowser = () => setIsFullscreen(isElementFullscreen(CanvasMountRef.current));

        FULLSCREEN_CHANGE_EVENTS.forEach(eventName => document.addEventListener(eventName, syncWithBrowser));
        return () => FULLSCREEN_CHANGE_EVENTS.forEach(eventName => document.removeEventListener(eventName, syncWithBrowser));
    }, []);

    const toggleFullscreen = useCallback(async () => {
        const previewContainer = CanvasMountRef.current;
        if (!previewContainer)
            return;

        try {
            await toggleElementFullscreen(previewContainer);
        } catch (error) {
            // The browser refuses when the page is not allowed to go fullscreen; there is nothing to recover.
            console.warn('The preview could not toggle fullscreen:', error);
        }
    }, []);

    // iPhone Safari has no Fullscreen API for elements.
    const isSupported = isFullscreenSupported(document.documentElement);

    return { isSupported, isFullscreen, toggleFullscreen };
};

export default useFullscreenPreview;
